/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * InfoOutlinedIcon - Auto-generated from icon.js
 */
export const InfoOutlinedIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		{...props}
	>
		<circle cx="8" cy="11.8281" r="0.78125" fill="#D0021B" />
		<path fillRule="evenodd" clipRule="evenodd" d="M8 0C3.57863 0 0 3.57803 0 8C0 12.4214 3.57803 16 8 16C12.4214 16 16 12.422 16 8C16 3.57863 12.422 0 8 0ZM8 14.75C4.26947 14.75 1.25 11.731 1.25 8C1.25 4.26947 4.26897 1.25 8 1.25C11.7305 1.25 14.75 4.26897 14.75 8C14.75 11.7305 11.731 14.75 8 14.75Z" fill="#D0021B" />
		<path fillRule="evenodd" clipRule="evenodd" d="M7.375 4.64117L7.375 9.95316C7.375 10.2984 7.65481 10.5782 8 10.5782C8.34519 10.5782 8.625 10.2984 8.625 9.95316V4.64117C8.625 4.64117 8.625 3.85608 8.08571 3.85608C7.375 3.85608 7.375 4.64117 7.375 4.64117Z" fill="#D0021B" />
	</svg>
);

export default InfoOutlinedIcon;
